import GOTUtil from '../utils/GOTUtil';

class FormItemConst
{
	static MAX_DATAGRIDWIDTH = 500;

	static displayLength_EN = 6;
	static displayLength_CH = 15;
	static displayLength_ENAddon = 5;
	static displayLength_CHAddon = 7;

	static DATAGRID_HEADER_HEIGHT = 25;

	static DATAGRID_ROW_HEIGHT = 25;//22;//25

	static EDITOR_HEIGHT = 22;

	static BUTTON_HEIGHT = 22;

	//static EDITOR_NOTEDIT_COLOR = "#F1F1F1";
	static EDITOR_NOTEDIT_COLOR = "#F6F7FB";

	static ARROWDOWN_BUTTON_WIDTH = 22;
	static DATAEDITOR_DATAGRID_ADDON_FOCUS = 2;

	static PLUGIN_TYPE_TREE = "Tree";
	static PLUGIN_TYPE_HTML = "Html";
	static PLUGIN_TYPE_RADIO = "Radio";
	static PLUGIN_TYPE_COMMENT = "BPMComment";
	static PLUGIN_TYPE_ATTACHMENT = "BPMAttachment"

	static BUTTON_SUBMIT_GROUPTYPE_QUERY_LABEL = "查询";
	static BUTTON_RESET_GROUPTYPE_QUERY_LABEL = "重置";
	static BUTTON_PROPERTY_QUERYTYPE_SUBMIT_VALUE = "QuerySubmit";
	static BUTTON_PROPERTY_QUERYTYPE_RESET_VALUE = "QueryReset";

	// static BUTTON_PROPERTY_QUERYTYPE_DATASETRESET_VALUE = "DataSetReset";

	// static BUTTON_PROPERTY_QUERYTYPE_DATASETEXPORT_VALUE = "DataSetExport";

	static DISPLAYLENGTH_DATE_DEFAULT = 13;


	static DECIMALEDITOR_DROPDOWN_NONE = "None";
	static DECIMALEDITOR_DROPDOWN_CACL = "Calculator";
	static DECIMALEDITOR_DROPDOWN_NUMKEYBOARD = "NumKeyBoard";


	static ALLOWEDIT_ALWAYS = "Always";
	static ALLOWEDIT_NEVER = "Never";
	static ALLOWEDIT_ONLYONCREATE = "OnlyOnCreate";

	static PROPERTY_MAINFORM_NAME = "MainForm";
	static PROPERTY_MAINFORM_NAME2 = "RefMenuItem";

	static PROPERTY_FORMTYPE_WORKFLOW = "WorkFlow";
	static PROPERTY_FORMTYPE_NORMAL = "Normal";
	static PROPERTY_FORMTYPE_REPORT = "Report";
	static PROPERTY_FORMTYPE_LOOKUP = "Lookup";
	static PROPERTY_FORMTYPE_SUBFORM = "SubForm";

	static DATEEDITOR_DEFAULT_DISPLAYLENGTH = 12;

	static EDITOR_VALUE_CHANGED_ERROR = 0;
	static EDITOR_VALUE_CHANGED_SUC = 1;

	static WILDCARD = "*";

	static getDisplayLengthWidth(length)
	{
		return length*15.6+10;
		
	}

	static isMaxControl(item)
	{
		let _type = item.type;
		return (_type == "Tab" || _type == "DataGrid" || _type == "Plugin");
	}

	//layout 主轴方向
	static containsMaxControl(item,layout)
	{
		let children = item.FormItem;
		if(children == null || children == undefined)
			return false;
		for(var i=0;i<children.length;i++)
		{
			let child = children[i];
			if(child.type == "Tab" || child.type == "DataGrid")
				return true;
			//TODO 需要根据Plugin实际情况来判断是否属于最大化控件
			if(child.type == "Plugin")
			{
				if(layout == "vertical")
				{
					let _height = GOTUtil.getPropertyValue(item,"Height");
					if(!_height)
						return true;
				}
				else
				{
					let _width = GOTUtil.getPropertyValue(item,"Width");
					if(!_width)
						return true;
				}
			}
			return FormItemConst.containsMaxControl(child);
		}
		return false;
	}
}

export default FormItemConst;




// WEBPACK FOOTER //
// ./src/formItem/FormItemConst.js